/* @ngInject */
function OnboardingVideoBannerController ($scope, $rootScope, UiElementViewLogService) {
  $scope.hideBanner = true

  activate()

  function activate () {
    UiElementViewLogService.shouldShowUiElement('onboardingVideoBanner', 3, $rootScope.oUser.id).then(shouldShowBanner => {
      $scope.hideBanner = !shouldShowBanner
    })
  }

  $scope.hideBannerClick = () => {
    $scope.hideBanner = true
  }

  $scope.getLinkUrl = () => {
    return $rootScope.isUser() ? 'https://ajuda.deskfy.io/pt-BR/articles/10207128-customizar-materiais-com-videos' : 'http://ajuda.deskfy.io/pt-BR/articles/10100074-criar-materiais-customizaveis-com-videos'
  }
}

export { OnboardingVideoBannerController }
